
  
/* REVIEW GLANCE */
function checkReviews(){
  //console.log($(".jdgm-rev-widg__reviews .jdgm-rev").first());
  if($('.jdgm-rev-widg__reviews .jdgm-rev').first().length){
  var reviewText = $('.jdgm-rev-widg__reviews .jdgm-rev').first().find(".jdgm-rev__body").text().substring(0, 150) + "...";
  var reviewAuthor = $('.jdgm-rev-widg__reviews .jdgm-rev').first().find(".jdgm-rev__author").html();

    //console.log(reviewText);
    //console.log(reviewAuthor);
    
  $(".t4s-product__info-wrapper .jdgm-preview-badge").append("<div class='review-text'>" + '"' + reviewText + '"' + "</div>");
  $(".t4s-product__info-wrapper .jdgm-preview-badge").append("<div class='review-author'>" + reviewAuthor + "</div>");
  $(".t4s-product__info-wrapper.template-product .jdgm-preview-badge .review-text").html("&quot;"+reviewText+"&quot;");
  $(".t4s-product__info-wrapper.template-product .jdgm-preview-badge .review-author").text(reviewAuthor);    
  
   clearInterval(myInterval);  
  
  }
  
}

setTimeout(function() {

$(document).ready(function() {

  $(document).on('cart:updated', function(event, cart) {
    // Check if the body has the 'sv' class
    if ($('body').hasClass('sv')) {
      // Redirect to the cart page
      window.location.href = '/sv/cart';
    }
  });
  
  $('body.sv .t4s-site-nav__cart').click(function(event) {
    console.log($(this));
    // Prevent any default actions if the body has the 'sv' class
    // Navigate to the href location
      window.location.href = '/sv/cart';
  });
});
  
  myInterval = setInterval(checkReviews, 500);
}, 2000);



